import { render } from "./TopTasks.vue?vue&type=template&id=2fe7c7e6&scoped=true"
import script from "./TopTasks.vue?vue&type=script&lang=js"
export * from "./TopTasks.vue?vue&type=script&lang=js"

import "./TopTasks.vue?vue&type=style&index=0&id=2fe7c7e6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fe7c7e6"]])

export default __exports__